import { useLayoutEffect, useMemo } from 'react';
import { useNavigation } from '@react-navigation/native';
import { useResponsive } from '@sg/garnish';

import type { HeaderIconItems } from '@order/components';
import { useHeaderLeft } from '@order/components';
import { useLocalizationContext } from '@order/Localization';

import { useNavigateBack } from '../../../../navigation';

// ─────────────────────────────────────────────────────────────────────────────

export const useSweetpassBillingHistoryNavigationOptions = () => {
  const { t } = useLocalizationContext();
  const { match } = useResponsive();
  const navigation = useNavigation();
  const navigateBack = useNavigateBack();

  const headerLeftItems = useMemo<HeaderIconItems>(
    () => [
      {
        key: 'navigate-back-btn',
        icon: 'IconArrowLeft',
        accessibilityLabel: t('general.go-back'),
        onPress: navigateBack,
      },
    ],
    [navigateBack, t],
  );

  const headerLeftXS = useHeaderLeft({ items: headerLeftItems });

  // ─────────────────────────────────────────────────────────────────────

  useLayoutEffect(() => {
    navigation.setOptions({
      headerLeft: match([headerLeftXS, undefined]),
      headerRight: null,
    });
  }, [headerLeftXS, match, navigation]);
};
